import React, { forwardRef } from "react";
import "./OneClickSection.css";
import { motion } from "framer-motion";
import { MdInsights, MdOutlineAdsClick, MdSpeed } from "react-icons/md";

const fadeUp = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.7, ease: "easeOut" },
  viewport: { once: true, amount: 0.25 },
};

const cards = [
  {
    icon: <MdInsights />,
    step: "Phase 01",
    title: "Discover & Plan",
    desc: "We audit your current digital presence, study your competitors, and build a custom roadmap aligned with your business goals.",
    bullets: ["Business audit", "Competitor research", "Custom strategy"],
  },
  {
    icon: <MdOutlineAdsClick />,
    step: "Phase 02",
    title: "Build & Launch",
    desc: "Our team designs and develops your website, sets up analytics, and launches with SEO foundations baked in from day one.",
    bullets: ["Design & development", "SEO setup", "Analytics tracking"],
  },
  {
    icon: <MdSpeed />,
    step: "Phase 03",
    title: "Grow & Optimize",
    desc: "We run marketing campaigns, optimize for conversions, and iterate based on real data to scale what works.",
    bullets: ["Marketing campaigns", "CRO improvements", "Monthly reporting"],
  },
];

const OneClickSection = forwardRef((_, ref) => {
  return (
    <section className="ocs" ref={ref} aria-label="Our approach">
      <div className="ocs__wrap">
        <motion.div className="ocs__head" {...fadeUp}>
          <div>
            <div className="ocs__badge">
              <span className="dot" aria-hidden="true" />
              Our Approach
            </div>
            <h2 className="ocs__title">
              Three phases to <span>digital success</span>.
            </h2>
            <p className="ocs__sub">
              A proven framework that takes you from zero online presence to a
              fully optimized, lead-generating digital asset.
            </p>
          </div>
          <div className="ocs__aside">
            <b>Typical timeline:</b>
            <p>
              Week 1–2: discovery & design • Week 3–4: development & launch •
              Ongoing: marketing & optimization
            </p>
          </div>
        </motion.div>

        <div className="ocs__grid">
          {cards.map((c, i) => (
            <motion.div key={i} className="ocs__card" {...fadeUp}>
              <div className="ocs__top">
                <div className="ocs__icon" aria-hidden="true">{c.icon}</div>
                <div className="ocs__step">{c.step}</div>
              </div>
              <h4 className="ocs__h4">{c.title}</h4>
              <p className="ocs__p">{c.desc}</p>
              <ul className="ocs__bullets">
                {c.bullets.map((b, idx) => <li key={idx}>{b}</li>)}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default OneClickSection;
